export default __webpack_public_path__ + "static/media/graph-trading.223d4a8c.png";